import React from 'react';

function DeleteEnquiry({ selectedRow }) {
  return (
    <>
      <div className="text-left px-2 pb-0">
        <h6>Following enquiry will be deleted and could not be recovered!!</h6>
        <ul>
          <li><b>Customer Name:</b> {selectedRow?.CustomerName}</li>
          <li><b>Mobile No:</b> {selectedRow?.MobileNo}</li>
          <li><b>Enquire For:</b> {selectedRow?.EnquireFor}</li>
        </ul>
      </div>
      <div id="DeleteEnquiryDetails" hidden>{JSON.stringify(selectedRow || {})}</div>
    </>
  );
}

export default DeleteEnquiry;